import React from "react";
import { Text, TouchableOpacity, View, Image } from "react-native";
import chatStyles from "../styles/chatStyles";
import styles from "../styles/styles";
import CustomInfoTip from "./toolTip";
const images = {
  post: require("../../assets/images/post.png"),
  email: require("../../assets/images/email.png"),
  agent: require("../../assets/images/agent.png"),
};
export const ChatButtons = (props) => (
  <View
    style={[
      chatStyles.buttonsRow,
      props.buttons.find((each) => each.icon || each.info)
        ? chatStyles.justContntLeft
        : null,
    ]}
  >
    {props.buttons.map((each, index) => (
      <React.Fragment key={`chatButtons${index}`}>
        <View
          nativeID={`chatButtons${index}`}
          style={[
            chatStyles.chatButtonCover,
            props.buttons.find((each) => each.icon || each.info)
              ? chatStyles.buttonWidth90
              : null,
          ]}
        >
          <TouchableOpacity
            disabled={props.disableOptions}
            style={[
              chatStyles.chatButton,
              props.disableOptions ? styles.disabledOpacity : null,
              // (each.icon || each.info) ? chatStyles.justContntLeft : null
            ]}
            onPress={() => {
              props.updateSentMessage(each.value);
            }}
          >
            {each.icon && (
              <Image
                style={
                  (chatStyles.chatIcons,
                  each.icon == "agent"
                    ? chatStyles.agent
                    : each.icon == "email"
                    ? chatStyles.mail
                    : chatStyles.postal)
                }
                source={images[each.icon]}
              ></Image>
            )}
            <Text
              style={
                each.icon
                  ? [chatStyles.chatButtonText, chatStyles.textPadding]
                  : [
                      chatStyles.chatButtonText,
                      // chatStyles.colorWhite
                    ]
              }
            >
              {each.name}
            </Text>
          </TouchableOpacity>
        </View>
        {each.info != "" && each.info && (
          <CustomInfoTip textToShow={each.info} />
        )}
      </React.Fragment>
    ))}
  </View>
);
